import {remCalc} from '_themeUtils'
import wallMixedImage from './partials/wallMixedImage'
import wallMixedVideo from './partials/wallMixedVideo'
import wallMixedCarousel from './partials/wallMixedCarousel'

const wallMixed = {
    WallMixed: {
        baseStyle: ({mobileSideBySide}) => ({
            wallMixedWrapper: {
                w: '100%',
                h: '100%',
                gridColumn: '1 / -1',
                overflow: 'hidden',
                flexDirection: 'column',
                pt: {base: remCalc(80)},
                pb: {base: remCalc(96)},
            },
            gridContainer: {
                gridColumnGap: '0',
            },
            gridThreeCol: {
                gridColumnGap: {base: remCalc(8)},
                padding: {base: `${remCalc(16)} ${remCalc(48)}`, lg: '0'},
            },
            gridFourCol: {
                gridColumnGap: {base: remCalc(8)},
                padding: {
                    base: mobileSideBySide ? `${remCalc(24)} ${remCalc(12)}` : `${remCalc(24)} ${remCalc(8)}`,
                    md: `${remCalc(0)} ${remCalc(16)}`,
                    lg: `${remCalc(0)} ${remCalc(16)}`,
                },
            },
            header: {
                w: '100%',
                alignItems: 'center',
                textAlign: 'center',
                gap: 'spacing.2',
                pb: 'spacing.6',
            },
            title: {
                textStyle: {base: 'paragraphMd'},
                fontWeight: 400,
                letterSpacing: '0.2em',
                color: 'color.text.black',
            },
        }),
    },
}

export default {...wallMixed, ...wallMixedImage, ...wallMixedVideo, ...wallMixedCarousel}
